<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo bg-white">
        <img src="/img/agentusername.png">
      </span>
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">AMOS365</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <!-- Dashboards -->
      <sidenav-router-link icon="fas fa-tachometer-alt" to="/" :exact="true">Dashboard</sidenav-router-link>
      <sidenav-router-link icon="fas fa-building" to="/agencies" v-if="this.$root.hasPermission(['agencies.view', 'agencies.manage'])">Agencies</sidenav-router-link>
      <sidenav-router-link icon="fas fa-users" to="/agents" v-if="this.$root.hasPermission(['agents.view', 'agents.manage'])">Agents</sidenav-router-link>
      <sidenav-router-link icon="fas fa-shield-alt" to="/carriers" v-if="this.$root.hasPermission(['carriers.view', 'carriers.manage'])">Carriers</sidenav-router-link>
      <sidenav-router-link icon="fas fa-address-card" to="/clients" v-if="this.$root.hasPermission(['clients.view', 'clients.manage'])">Clients</sidenav-router-link>
      <sidenav-router-link icon="fas fa-file-contract" to="/policies" v-if="this.$root.hasPermission(['policies.view', 'policies.manage'])">Policies</sidenav-router-link>
      <!-- <sidenav-router-link icon="fas fa-book" to="/products" v-if="this.$root.hasPermission(['products.view', 'products.manage'])">Products</sidenav-router-link> -->

      <sidenav-menu icon="fas fa-book" :active="isMenuOpen('/products')" :open="isMenuOpen('/products')" v-if="this.$root.hasPermission(['products.view', 'products.manage'])">
        <template slot="link-text">Products</template>
        <sidenav-router-link to="/products" :exact="true">Products List</sidenav-router-link>
        <sidenav-router-link to="/products/levels/history" :exact="true">Product Level History</sidenav-router-link>
      </sidenav-menu>

      <sidenav-router-link icon="fas fa-wrench" to="/contracts" v-if="this.$root.hasPermission(['contracts.view', 'contracts.manage'])">Contracts</sidenav-router-link>
      <!-- UI elements -->
      <sidenav-menu icon="fas fa-chart-bar" :active="isMenuOpen('/reports')" :open="isMenuOpen('/reports')" v-if="this.$root.hasPermission(['reports.view', 'reports.manage.all'])">
        <template slot="link-text">Reports</template>
        <sidenav-router-link to="/reports" :exact="true">Saved Reports</sidenav-router-link>
        <sidenav-router-link to="/reports/custom" :exact="true">Custom</sidenav-router-link>
        <sidenav-router-link to="/reports/downline" :exact="true">Downline</sidenav-router-link>
        <sidenav-router-link to="/reports/schedules" :exact="true">Schedules</sidenav-router-link>
      </sidenav-menu>

      <sidenav-divider class="mb-1"/>

      <!-- UI elements -->
      <sidenav-menu icon="fas fa-cogs" :active="adminOpen()" :open="adminOpen()" v-if="this.$root.hasPermission(['admin.billing', 'users.view', 'users.manage'])">
        <template slot="link-text">Admin</template>
        <sidenav-router-link to="/admin/billing" v-if="this.$root.hasPermission(['admin.billing'])">Billing</sidenav-router-link>
        <sidenav-router-link to="/admin/settings" v-if="this.$root.hasPermission(['admin.billing'])">Settings</sidenav-router-link>
        <sidenav-router-link to="/users" v-if="this.$root.hasPermission(['users.view', 'users.manage'])">Users</sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    },
    user_reports() {
        return this.$store.state.user.reports.filter(report => {return report.is_starred == 1});
    }
  },

  methods: {
    savedReportUrl(report) {
      let url_map = {
        'Liaison': '/reports/liaison',
        'Pareto': '/reports/pareto',
        'Activity': '/reports/activity',
        'Invoicing': '/reports/invoicing',
        'Billing': '/reports/billing',
        'Payroll': '/reports/payroll',
      }

      let url = url_map[report.report_class];
      url += `?report_id=${report.id}`

      return url;
    },
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    adminOpen(){
      //Setup
      var open = false;

      //Ruotes
      var routes = [
        '/admin/billing',
        '/admin/settings',
        '/users',
      ];

      //Check all
      for (var i = 0; i < routes.length; i++)
      {
        if(this.isMenuOpen(routes[i]))
        {
          open = true;
          break;
        }
      }

      //Send it
      return open;
    },

    toggleSidenav () {
      console.log('Toggling');
      console.log(this.layoutHelpers);
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
